<template>
  <youtube :video-id="preRegisteredValues"></youtube>
</template>
<script>
export default {
  props:{
    preRegisteredValues:{
      type:String,
      default:''
    }
  }
}
</script>